import React from "react";

import Fallback from "../Fallback/Empty";
import Td from "./Td";

const Empty = ({ colSpan, rowSpan }) => {
  return (
    <tr>
      <Td {...{ colSpan, rowSpan }} className="py-12">
        <Fallback />
      </Td>
    </tr>
  );
};

export default Empty;
